import { render, staticRenderFns } from "./StatusReasons.vue?vue&type=template&id=18456b23&scoped=true"
import script from "./StatusReasons.vue?vue&type=script&lang=js"
export * from "./StatusReasons.vue?vue&type=script&lang=js"
import style0 from "./StatusReasons.vue?vue&type=style&index=0&id=18456b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18456b23",
  null
  
)

export default component.exports